import { MutationDefinition } from './types';

export const defineMutation = <
  TParams = void,
  TResult = void,
  TError extends Error = Error,
>(
  definition: MutationDefinition<TParams, TResult, TError>
): MutationDefinition<TParams, TResult, TError> => Object.freeze(definition);
